module.exports = __webpack_public_path__ + "static/media/1024535.f6b351c2.jpg";